<!-- 滚动条 -->
<template>
  <div
    class="scroll-container"
    :style="style"
  >
    <el-scrollbar
      ref="scroll"
      style="height:100%"
    >
      <slot />
    </el-scrollbar>
  </div>
</template>

<script>
import ResizeMixin from './resizeHandler'
const cubic = value => Math.pow(value, 3)
const easeInOutCubic = value => value < 0.5
  ? cubic(value * 2) / 2
  : 1 - cubic((1 - value) * 2) / 2
export default {
  mixins: [ResizeMixin],
  props: {
    size: {
      type: String,
      default: 'percent'
    },
    height: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      style: {
        width: '100%',
        height: this.$store.state.app.container.height - this.height + 'px'
      }
    }
  },
  created () {
    this.style.height = this.$store.state.app.container.height - this.height + 'px'
    this.$bus.$on('scrollToTop', () => {
      this.toTop()
    })
  },
  beforeDestroy () {
    this.$bus.$off('scrollToTop')
  },
  methods: {
    toTop () {
      // el-scrollbar 容器
      const el = this.$refs['scroll'].wrap

      const beginTime = Date.now()
      const beginValue = el.scrollTop
      const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16))
      const frameFunc = () => {
        const progress = (Date.now() - beginTime) / 500
        if (progress < 1) {
          el.scrollTop = beginValue * (1 - easeInOutCubic(progress))
          rAF(frameFunc)
        } else {
          el.scrollTop = 0
        }
      }
      rAF(frameFunc)
    }
  }
}
</script>
<style lang='stylus' scoped></style>
